export function genKey() {
  const str1 = (Date.now() * Math.round(1 + Math.random() * 10)).toString(16);
  const str2 = (Date.now() * Math.round(1 + Math.random() * 10)).toString(16);
  const str3 = (Date.now() * Math.round(1 + Math.random() * 10)).toString(16);
  const str4 = (Date.now() * Math.round(1 + Math.random() * 10)).toString(16);
  return (str1 + str2 + str3 + str4).slice(0, 32);
}



// WEBPACK FOOTER //
// ./src/frontend/helpers/gen-key.js